import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  public hideHeader() {
    const headerSize = document.getElementById('tt-header').getBoundingClientRect().height;
    document.documentElement.style.setProperty('--tt-header-top', `-${headerSize}px`);
  }

  public showHeader() {
    document.documentElement.style.setProperty('--tt-header-top', `0px`);
  }
}
